import { render, staticRenderFns } from "./EditInventoryConsumableCatalogDrawer.vue?vue&type=template&id=c6383534"
import script from "./EditInventoryConsumableCatalogDrawer.vue?vue&type=script&lang=js"
export * from "./EditInventoryConsumableCatalogDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports